<template>
  <div class="content">
    <arrorImg bg="white"></arrorImg>
    <navBar title="充值记录" color="#ffffff"></navBar>
    <div class="title-recharge">
      <div v-for="(item, index) in title" :key="index">
        <span
          :class="rechargeType == index + 1 ? 'active' : ''"
          @click="changeCharge(index)"
          >{{ item }}</span
        >
      </div>
    </div>
    <div class="content-box">
      <div class="content-list" v-if="!isEmpaty">
        <ul
          v-infinite-scroll="loadMore"
          :infinite-scroll-disabled="loading"
          infinite-scroll-distance="10"
        >
          <li v-for="(item, index) in List" :key="index" class="list-item">
            <div>
              <span>{{ item.description }}</span>
              <span>{{ item.payTime }}</span>
            </div>
            <div>
              <div>
				  <img v-if="item.payType == 3"
                src="../../../static/recharge_custom.png"
                alt=""
              />
			  </div>
         <span v-if='rechargeType == 1'>{{(item.amount / 100).toFixed(2)}}</span>
         <span v-if='rechargeType == 2&&item.giftType==0'>{{item.currency}}书币</span>
         <span v-if='rechargeType == 2&&item.giftType==1'>{{(item.giftDays>=0) ?'':'-'}}会员{{(item.giftDays>=0) ?item.giftDays:-item.giftDays}}天</span>
            </div>
          </li>
        </ul>
        <div class="load-more">
          <span>{{ !isLoading ? "加载中" : loadingText }}</span>
        </div>
      </div>
      <div class="no-log" v-else>
        <img src="../../../static/no-log.png" alt="" />
        <span>暂无记录~</span>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, MessageBox, InfiniteScroll } from "mint-ui";
import arrorImg from "../../components/arrow-img.vue";
import navBar from "../components/navbar.vue";
export default {
  components: {
    arrorImg,
    navBar,
  },
  data() {
    return {
      title: ["充值", "赠送"],
      List: [],
      pageNo: 1,
      pageSize: 12,
      rechargeType: 1,
      pageCount: 1,
      loadingText: "没有更多了",
      isEmpaty: false,
      isEntranceData: "",
      loading: false,
      isLoading: false,
      pageType:''
    };
  },
  mounted() {
    if (this.$route.query.isEntranceData) {
      this.isEntranceData = this.$route.query.isEntranceData;
    }
    this.pageType= this.$route.query.pageType;
    var openid = this.$base.getStorage("openid");
    var isWxAuthorized = this.$base.getStorage("isWxAuthorized");
    	 var city = this.$base.getStorage("city");
    if (!openid) {
      //静默登录手动登录
      // #ifdef H5
      // #endif
    } else if (isWxAuthorized == 0&&city==1 && openid && !this.$store.state.user.isSNS) {
      this.$base.setStorage("isSNS", true);
      this.$store.state.user.isSNS = true;
      this.$commonApi.snsapiUserinfo();
      this.getCharge();
      this.insertPageAccessData();
    } else {
      this.getCharge();
      this.insertPageAccessData();
    }
    this.$commonApi.share();
  },
  methods: {
    loadMore() {
      this.loading = true;
      if (this.pageNo < this.pageCount) {
        this.pageNo += 1;
        this.getCharge();
      } else {
        this.loadingText = "没有更多了";
        this.loading = false;
      }
    },

    insertPageAccessData() {
      var pageType = "";
      if (this.pageType === "bookCity") {
        pageType = "书城";
      } else if (this.pageType === "bookRecharge") {
        pageType = "充值中心";
      }else if (this.pageType === "bookMine") {
        pageType = "我的";
      }
      var params = {
        pageName: "充值记录",
        pageRemark: '上级页面：'+pageType+";"+(this.rechargeType == 1 ? "充值记录" : "赠送记录"),
        isEntranceData: this.isEntranceData,
      };
      this.$api.insertPageAccessData(params).then((res) => {});
    },
  
    changeCharge(index) {
      this.rechargeType = index + 1;
      this.pageNo = 1;
      this.insertPageAccessData();
      this.getCharge();
    },
    getCharge() {
      var params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        rechargeType: this.rechargeType, //1充值，2赠送 0所有
      };
      this.isLoading = false;
      this.$api.charge(params).then((res) => {
        if (res.status == 1) {
          this.pageCount = res.pages;
          if (this.pageNo == 1) {
            this.$nextTick(() => {
              window.scrollTo(0, 0);
            });
            this.List = res.data;
            if (this.pageCount <= 1) {
              this.loadingText = "没有更多了";
            } else {
              this.loadingText = "加载中...";
            }
          } else {
            this.List = this.List.concat(res.data);
          }
          if (this.List.length == 0) {
            this.isEmpaty = true;
          } else {
            this.isEmpaty = false;
          }
          this.isLoading = true;
        }
      });
    },
  },
};
</script>

<style scoped>
.content {
  /* height:calc(48px + env(safe-area-inset-bottom)); */
  padding-bottom: constant(safe-area-inset-bottom);
  /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom);
  /* 兼容 iOS >= 11.2 */
  /* box-sizing: content-box; */
}
.title-recharge {
  display: flex;
  border-bottom: 1px solid #f3f3f3;
  background-color: #ffffff;
  position: fixed;
  width: 100%;
  left: 0;
  z-index: 99;
  top: calc(44px + env(safe-area-inset-top));
}
.content-box {
  padding-top: calc(88px + env(safe-area-inset-top));
}

.title-recharge > div {
  width: 50%;
  flex: 1;
  text-align: center;
  padding-top: 12px;
  padding-bottom: 10px;
}

.title-recharge span {
  font-size: 16px;
  color: #aaaaaa;
  padding-bottom: 4px;
  border-bottom: 3px solid #ffffff;
}

.title-recharge span.active {
  color: #333333;
  border-bottom: 3px solid #333333;
}
.list-item {
  padding: 20px 16px 12px 16px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f3f3f3;
}

.list-item img {
  width: 36px;
  height: 36px;
  margin-right: 30px;
}
.list-item > div > span {
  display: block;
}

.list-item > div:nth-of-type(1) > span:nth-child(1) {
  font-size: 14px;
  color: #333333;
  font-weight: bold;
}

.list-item > div > span:nth-child(2) {
  font-size: 12px;
  color: #aaaaaa;
  margin-top: 4px;

}
.list-item > div:nth-of-type(2) {
  display: flex;
  width: 130px;
  justify-content: space-between;
}
.list-item > div:nth-of-type(2) > span {
  font-size: 14px;
  color: #de3b34;
  margin-top: 8px;
}

.load-more {
  text-align: center;
  font-size: 12px;
  color: #aaaaaa;
  padding: 16px 0px;
}

.no-log {
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.no-log img {
  width: 128px;
  height: 128px;
  display: block;
  margin: 0 auto;
}

.no-log span {
  display: block;
  font-size: 14px;
  color: #666666;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/bookRecharge/index.vue